import React from 'react';
import { MessageSquare } from 'lucide-react';
// v3 (2026-09-22): same waiting-state pieces as the idle screen, same scope.
import '../../styles/idle-v3.css';

// Chat tab — roadmap placeholder. Digital channels are a Phase 2 add-on.
export default function ChatPanel() {
  return (
    <main className="centre-panel idle-v3-screen">
      <div className="waiting-state">
        <span className="waiting-icon"><MessageSquare size={30} /></span>
        <h2 className="waiting-title">Chat</h2>
        <p className="waiting-sub">
          Web chat lands here as part of the digital channels rollout.
          Voice and scheduled callbacks are live today.
        </p>
      </div>
    </main>
  );
}
